import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { GridAutoColumn2 } from "../../styles/customStyles/customStyles";
// import PatientDetails from "./UserDetails";
// import RecordDetails from "./RecordDetails";
import useMasterApi from "../../services/useMasterApi";
import { ENDPOINT } from "../../services/endPoints";
import { Divider } from "@mui/material";
import { GridAutoColumn2 } from "../../styles/customStyles/customStyles";
import PatientDetails from "./PatientDetails";
import RecordDetails from "./RecordDetails";

const UserDetails = () => {
  const { patient_code } = useParams();
  const { get, data, error, loading } = useMasterApi();
  const [patienDetails, setPatienDetails] = useState({});

  useEffect(() => {
    get(`${ENDPOINT.PATIENT_DETAILS}/${patient_code}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient_code]);

  useEffect(() => {
    if (data.success) {
      setPatienDetails(data.data);
    }
  }, [data]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {Object.keys(patienDetails).length ? (
        <>
          <GridAutoColumn2>
            <PatientDetails patienDetails={patienDetails} />
          </GridAutoColumn2>
          <Divider />

          <RecordDetails recordDetails={patienDetails} endPoint={`${ENDPOINT.PATIENT_DETAILS}/${patient_code}`} />
        </>
      ) : null}
    </>
  );
};

export default UserDetails;
